"use client";

import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination, Autoplay } from "swiper/modules";
import "swiper/css";
import "swiper/css/pagination";
import HighlightCard from "./HighlightCard";

const MobileSlider = ({ cards }) => {
  return (
    <div className="w-full">
      <Swiper
        modules={[Pagination, Autoplay]}
        spaceBetween={20}
        slidesPerView={1}
        pagination={{
          clickable: true,
          dynamicBullets: true
        }}
        autoplay={{
          delay: 4000,
          disableOnInteraction: false
        }}
        style={{
          "--swiper-pagination-color": "#B3594D",
          "--swiper-pagination-bullet-inactive-color": "#B3594D",
          "--swiper-pagination-bullet-inactive-opacity": "0.3"
        }}
        className="w-full"
      >
        {cards.map((card, index) => (
          <SwiperSlide key={index} className="pb-12 py-2">
            <HighlightCard {...card} />
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  );
};

export default MobileSlider;
